import styled from '@emotion/styled';

export const withoutOutline = (
  Component: React.FC<React.PropsWithChildren<any>>, // eslint-disable-line @typescript-eslint/no-explicit-any
  hasMaxWidth?: boolean
) => styled(Component)`
  &:focus {
    outline: 2px solid transparent;
    outline-offset: 4px;
  }
  ${hasMaxWidth ? 'max-width: 100%;' : null}
`;
